

export const CHAT_USERS_REQUEST = "CHAT_USERS_REQUEST";
export const CHAT_USERS_SUCCESS = "CHAT_USERS_SUCCESS";
export const CHAT_USERS_FAIL = "CHAT_USERS_FAIL";


export const GET_PRIVATE_CONVERSATIONS_REQUEST = "GET_PRIVATE_CONVERSATIONS_REQUEST";
export const GET_PRIVATE_CONVERSATIONS_SUCCESS = "GET_PRIVATE_CONVERSATIONS_SUCCESS";
export const GET_PRIVATE_CONVERSATIONS_FAIL = "GET_PRIVATE_CONVERSATIONS_FAIL";

export const SINGLE_CONVERSATION_REQUEST = "SINGLE_CONVERSATION_REQUEST";
export const SINGLE_CONVERSATION_SUCCESS = "SINGLE_CONVERSATION_SUCCESS";
export const SINGLE_CONVERSATION_FAIL = "SINGLE_CONVERSATION_FAIL";


export const SEND_PRIVATE_MESSAGE_REQUEST = "SEND_PRIVATE_MESSAGE_REQUEST";
export const SEND_PRIVATE_MESSAGE_SUCCESS = "SEND_PRIVATE_MESSAGE_SUCCESS";
export const SEND_PRIVATE_MESSAGE_RESET = "SEND_PRIVATE_MESSAGE_RESET";
export const SEND_PRIVATE_MESSAGE_FAIL = "SEND_PRIVATE_MESSAGE_FAIL";


export const CLEAR_CONVERSATION_REQUEST = "CLEAR_CONVERSATION_REQUEST";
export const CLEAR_CONVERSATION_SUCCESS = "CLEAR_CONVERSATION_SUCCESS";
export const CLEAR_CONVERSATION_RESET = "CLEAR_CONVERSATION_RESET";
export const CLEAR_CONVERSATION_AIL = "CLEAR_CONVERSATION_FAIL";




export const CLEAR_ERRORS = "CLEAR_ERRORS";

